$(document).ready(function(){
	if ($('#map').length) {
		if (!mapboxgl.supported()) {
			alert('Your browser does not support Mapbox GL');
		} else {

			// -- init map --
			mapboxgl.accessToken = 'pk.eyJ1IjoiZXZlcnl0aGluZ2lzZnVuIiwiYSI6IkVkalZJRUkifQ.i_Taxju9f5wO9aUyOF7Gyg';
			var map = new mapboxgl.Map({
				container: 'map',
				style: 'mapbox://styles/everythingisfun/cl1urljvq000914pdohhu1kac',
				center: [5.92, 49.98],
				zoom: 5,
				maxBounds: [
					[5.730743408203125, 49.453842594330716],
					[6.513519287109375, 50.1874507432253]
				] 
			});


			// -- show map controls --
			map.addControl(new mapboxgl.NavigationControl());


			// -- load geojson data (features) --
			var geojson = [];
			const categoryId = $('.main').attr('data-category-id');
			if (categoryId != undefined) {
				$.ajax({
				  type: 'GET',
				  url: 'actions/utilities-module/utilities/get-addresses',
				  data: {
				  	'categoryId' : $('.main').attr('data-category-id')
				  },
				  dataType: 'json',
				  success: function(response, statut){
				    geojson = response;
				    loadGeojsonData();
				  },
				  error: function(response, statut, error){
				    geojson = response;
				  }
				});
			}

			// -- functions > load geojson data (features) --
			const loadGeojsonData = function(){

				// -- fit map to wiltz --
				map.fitBounds([
					[5.8783721923828125, 49.93509096525814],
					[5.9827423095703125, 50.032445247495104]
				]);

				for (const feature of geojson.features) {
				
					// -- create markers --
					const el = document.createElement('div');
					const width = feature.properties.iconSize[0];
					const height = feature.properties.iconSize[1];
					el.className = 'marker';
					el.style.backgroundImage = `url(`+window.location.origin+`/assets/img/icon-marker.svg)`;
					el.style.width = `${width}px`;
					el.style.height = `${height}px`;
					el.style.backgroundSize = '100%';
					el.setAttribute('data-id',`entryId--${feature.properties.id}`);

					// -- create popup --
					const popup = new mapboxgl.Popup({ anchor:'top', offset:25, closeButton:false, maxWidth:'150px' }).setHTML(
						'<strong>'+ feature.properties.society + '</strong>' +
						'<p>'+ feature.properties.address.address + '</p>'
					);

					// -- add feature to map --
					const marker = new mapboxgl.Marker(el)
					.setLngLat(feature.geometry.coordinates)
					.setPopup(popup)
					.addTo(map);

					// -- action : click on marker --
					marker.getElement().addEventListener('click', (e) => { 
						if (marker.getElement().classList.contains('active') == false) {
							highlightFeatureOff();
							popup.addTo(map);
							marker.getElement().classList.toggle('active');
							map.flyTo({
								center: marker._lngLat,
								zoom: 15,
								essential: true
							});

						} else {
							highlightFeatureOff();
						}
						e.stopPropagation();
					}, false);

				}

				// -- action : click on show on map --
				$(document).on('click', '.btn--showOnMap', function(e){
					var id = $(this).parents('.card--address').attr('id');
					$(`.marker[data-id="${id}"]`).click();
				});

				// -- action : click on map --
				map.on('click', function(e){
					highlightFeatureOff();
				});

				// -- action : click on marker --
				$('.marker').on('click', function(e){
					var dataId = $(this).attr('data-id');
					var el = $('#'+dataId);
					if ($(window).width() < 768) {
						// -- slick go to --
						var index = el.parent('.slick-slide').attr('data-slick-index');
						$('.slider__addresses')[0].slick.slickGoTo(index);
					} else {
						// -- scroll to --
						var leftSideInner = $('.leftSide .inner');
						leftSideInner.animate({
					    scrollTop: el.offset().top - leftSideInner.offset().top + leftSideInner.scrollTop()
						});
					}
				});

			}

			// -- functions > desactive highlighted feature --
			const highlightFeatureOff = function(){
				const markers = document.querySelectorAll('.marker');
			 	const popup = document.getElementsByClassName('mapboxgl-popup');
			 	// -- desactive markers --
			  for (var i = 0; i < markers.length; i++) {
			    markers[i].classList.remove('active');
			  }
			 	// -- desactive popup --
				if (popup.length) {
			    popup[0].remove();
				}
			}

		}
	}
});